<template>
  <div >
    <b-dropdown aria-role="list" :position="position" class="dropDownButtonAnnotation'" :expanded="true" >
      <template #trigger="{ active }">
        <w-button size="small" color="outlined" icon="plus"  :expanded="true">
          {{ $t('createWeetComponent.advancedEditing.annotationMode.add') }}
        </w-button>
      </template>
      <b-dropdown-item aria-role="listitem" class="itemSelection" @click="createAnnotationText()">
        <w-icon icon="text" class="iconItem" /> {{ $t('createWeetComponent.advancedEditing.annotationMode.type.text') }}
      </b-dropdown-item>
      <b-dropdown-item aria-role="listitem" class="itemSelection">
        <b-upload accept=".png,.jpeg,.jpg,.gif" class="itemSelection" v-model="fileImage" @input="uploadAndCreateAnnotationImage">
          <w-icon icon="image-outline" class="iconItem"/> {{ $t('createWeetComponent.advancedEditing.annotationMode.type.image') }}
        </b-upload>
      </b-dropdown-item>
      <b-dropdown-item aria-role="listitem" class="itemSelection" @click="openIconPanels">
        <w-icon icon="alert-circle-outline" class="iconItem" /> {{ $t('createWeetComponent.advancedEditing.annotationMode.type.icon') }}
      </b-dropdown-item>
      <b-dropdown-item aria-role="listitem" class="itemSelection"  @click="openShapePanels" >
        <w-icon icon="shape-plus-outline" class="iconItem"/> {{ $t('createWeetComponent.advancedEditing.annotationMode.type.shape') }}
      </b-dropdown-item>
    </b-dropdown>

    <!-- PANEL ICONS CHOOSE -->
    <w-modal :active="showIconPanel" :modal="true">
      <CenterCenter>
        <div class="containerIconsAnnotation">
          <div class="titleIconChoose">
            {{$t('createWeetComponent.advancedEditing.annotationMode.addModal.titleIcon')}}
          </div>
          <div class="iconsPanel">
            <div class="iconButtonSelector"  v-for="(icon,index) of overlayIcons" :key="'icon'+icon+index"
            @click="createIconAnnotation(icon)">
              <w-tool-tip :label="$t('createWeetComponent.advancedEditing.annotationMode.addModal.chooseTooltip',{icon: icon})" position="top">
                <w-icon :icon="icon" size="large" />
              </w-tool-tip>
            </div>
          </div>
          <div class="lineButton">
            <w-button color="outlined" class="buttonAnnotationLine" @click="cancelPanels">{{$t('generic.cancel')}}</w-button>
          </div>
        </div>
      </CenterCenter>
    </w-modal>


    <!-- PANEL SHAPE CHOOSE -->
    <w-modal :active="showShapePanel" :modal="true">
      <CenterCenter>
        <div class="containerIconsAnnotation forShape ">
          <div class="titleIconChoose">
            {{$t('createWeetComponent.advancedEditing.annotationMode.addModal.titleShape')}}
          </div>
          <div class="iconsPanel">
            <div class="iconButtonSelector"  v-for="(icon,index) of overlayShapes" :key="'icon'+icon+index"
                 @click="createShapeAnnotation(icon)">
              <w-tool-tip :label="$t('createWeetComponent.advancedEditing.annotationMode.addModal.chooseTooltip',{icon: icon})" position="top">
                <w-icon :icon="icon" size="large" />
              </w-tool-tip>
            </div>
          </div>
          <div class="lineButton">
            <w-button color="outlined" class="buttonAnnotationLine" @click="cancelPanels">{{$t('generic.cancel')}}</w-button>
          </div>
        </div>
      </CenterCenter>
    </w-modal>
  </div>
</template>

<script lang="ts">
import {Component, Prop, Vue} from 'vue-property-decorator';
import store from '@/store';
import WButton from '@/components/wrapper/w-button.vue';
import WIcon from "@/components/wrapper/w-icon.vue";
import {
  Annotation,
  AnnotationPosition,
  AnnotationTheme,
  AnnotationType
} from "@/store/annotation/annotationModel";
import {CREATE_ANNOTATION, SELECT_ANNOTATION} from "@/store/annotation/annotationAction";
import {Weet} from "@/store/weet/weetModel";
import {SEEK_PLAYER} from "@/store/timeLine/timeLineAction";
import {alertSuccess, closeLoading, showLoading} from "@/utils/dialog";
import WModal from "@/components/wrapper/w-modal.vue";
import CenterCenter from "@/components/layout/CenterCenter.vue";
import WToolTip from "@/components/wrapper/w-toolTip.vue";

@Component({
  components: {WToolTip, CenterCenter, WModal, WIcon, WButton},
})
export default class CreateAnnotationButton extends Vue {
  @Prop()
  private weet!: Weet;

  @Prop({default:'is-top-right'})
  private position!:string;


  private annotationDefaultDurationTime = 5000;

  private fileImage:File|null=null;

  private showIconPanel=false;
  private showShapePanel=false;

  private overlayIcons = [
    "account-outline",            // Utilisateur
    "account-group-outline",      // Groupe d'utilisateurs
    "alert-outline",              // Alerte
    "alert-circle-outline",       // Alerte circulaire
    "check-circle-outline",       // Coche (succès)
    "close-circle-outline",       // Cercle de fermeture
    "cloud-outline",              // Cloud
    "cloud-upload-outline",       // Cloud upload
    "camera-outline",     // Caméra contour
    "cogs",               // Réglages / Engrenages
    "comment-outline",            // Commentaire
    "credit-card-outline",        // Carte de crédit
    "delete-outline",             // Supprimer
    "delete-circle-outline",      // Supprimer (cercle)
    "download-outline",           // Télécharger
    "email-outline",              // Email
    "email-open-outline",         // Email ouvert
    "exclamation-thick",  // Exclamation épaisse
    "file-outline",               // Fichier
    "folder-outline",             // Dossier
    "help-circle-outline",        // Aide (cercle)
    "home-outline",               // Maison
    "information-outline",// Information contour
    "link",               // Lien
    "earth",           // Localisation
    "lock-outline",               // Verrouiller
    "lock-open-outline",          // Déverrouiller
    "login",              // Connexion
    "logout",             // Déconnexion
    "magnify",            // Loupe
    "map-outline",                // Carte
    "message-outline",            // Message
    "pencil",             // Crayon (modifier)
    "phone",              // Téléphone
    "play-circle-outline",        // Lecture (cercle)
    "pause-circle-outline",       // Pause (cercle)
    "refresh",            // Rafraîchir
    "repeat",             // Répéter
    "search-web",         // Recherche web
    "file-outline",           // Paramètres
    "share",              // Partager
    "sync",               // Synchronisation
    "trash-can-outline",          // Poubelle
    "upload",             // Téléverser
    "wifi",               // Wifi
      "eye-outline",
      "star-shooting-outline",
      "decagram-outline",
      "calendar-blank",
      "factory",
      "heart-outline",
      "lotion-outline",
    "pig-variant-outline",
    "tree-outline"
  ];
  private overlayShapes=[
    'circle-outline',
    'circle',
    'square-outline',
    'square',
    'rectangle-outline',
    'rectangle',
    'triangle-outline',
    'triangle',
    'triangle-down-outline',
    'triangle-down',
    'star-outline',
    'star',
    'pentagon-outline',
    'pentagon',
    'arrow-top-left-bold-outline',
    'arrow-top-right-bold-outline',
    'arrow-left',
    'arrow-bottom-left',
    'arrow-down',
    'arrow-bottom-right',
    'arrow-right',
    'arrow-top-right',
    'arrow-up',
    'arrow-top-left',
    'arrow-left-bold',
    'arrow-down-bold',
    'arrow-right-bold',
    'arrow-up-bold',
    'arrow-up-left-bold',
    'arrow-left-top-bold',
    'arrow-right-bottom-bold',
    'arrow-down-left-bold'

  ]

  get timePlayer(): number {
    return store.getters.getTimerPlayer
  }
  private async createAnnotationText() {
    const annotation = new Annotation();
    annotation.type = AnnotationType.TEXT;
    if(this.timePlayer<500){
      annotation.time = 500;
    }else{
      annotation.time=this.timePlayer;
    }
    annotation.duration = this.annotationDefaultDurationTime;
    annotation.positionType = AnnotationPosition.TOP_RIGHT;
    annotation.theme = AnnotationTheme.DEFAULT;
    annotation.iconMD = "";
    annotation.profil = false;
    annotation.interactionUrl = "";
    annotation.user = null;
    annotation.sound = false;
    annotation.width=20;
    annotation.height=20;
    annotation.positionX=20;
    annotation.positionY=20;
    annotation.urlContent=""
    annotation.textContent=this.$t('createWeetComponent.advancedEditing.annotationMode.edit.placeholder').toString()
    annotation.colorBack=store.getters.getAnnotationBackgroundColor|| store.getters.getThemeColor
    annotation.colorFront=store.getters.getAnnotationColor|| "#FFFFFF"
    var annotationCreated=await store.dispatch(CREATE_ANNOTATION, {weetID: this.weet.weetID, annotation: annotation});
    store.dispatch(SELECT_ANNOTATION,annotationCreated);
    store.dispatch(SEEK_PLAYER, annotation.time)

  }


  private async uploadAndCreateAnnotationImage(file:File){
    const annotation = new Annotation();
    annotation.type = AnnotationType.IMAGE;
    showLoading()
    if(this.timePlayer<500){
      annotation.time = 500;
    }else{
      annotation.time=this.timePlayer;
    }
    annotation.duration = this.annotationDefaultDurationTime;
    annotation.positionType = AnnotationPosition.TOP_RIGHT;
    annotation.theme = AnnotationTheme.DEFAULT;
    annotation.iconMD = "";
    annotation.profil = false;
    annotation.interactionUrl = "";
    annotation.user = null;
    annotation.sound = false;
    annotation.width=20;
    annotation.height=20;
    annotation.positionX=20;
    annotation.positionY=20;
    annotation.textContent=""
    annotation.urlContent=await this.convertFileToBase64(file);
    annotation.colorBack=store.getters.getAnnotationBackgroundColor|| store.getters.getThemeColor
    annotation.colorFront=store.getters.getAnnotationColor|| "#FFFFFF"
    var annotationCreated=await store.dispatch(CREATE_ANNOTATION, {weetID: this.weet.weetID, annotation: annotation});
    store.dispatch(SELECT_ANNOTATION,annotationCreated);
    store.dispatch(SEEK_PLAYER, annotation.time)
    closeLoading()
  }

  private async createIconAnnotation(icon:string){
    this.cancelPanels();
    const annotation = new Annotation();
    annotation.type = AnnotationType.ICON;
    annotation.iconMD=icon;
    if(this.timePlayer<500){
      annotation.time = 500;
    }else{
      annotation.time=this.timePlayer;
    }
    annotation.duration = this.annotationDefaultDurationTime;
    annotation.positionType = AnnotationPosition.TOP_RIGHT;
    annotation.theme = AnnotationTheme.DEFAULT;
    annotation.profil = false;
    annotation.interactionUrl = "";
    annotation.user = null;
    annotation.sound = false;
    annotation.width=10;
    annotation.height=10;
    annotation.positionX=20;
    annotation.positionY=20;
    annotation.textContent=""
    annotation.urlContent=""
    annotation.colorBack=store.getters.getAnnotationBackgroundColor|| "#FFFFFF"
    annotation.colorFront=store.getters.getAnnotationColor|| store.getters.getThemeColor
    var annotationCreated=await store.dispatch(CREATE_ANNOTATION, {weetID: this.weet.weetID, annotation: annotation});
    store.dispatch(SELECT_ANNOTATION,annotationCreated);
    store.dispatch(SEEK_PLAYER, annotation.time)
  }

  private async createShapeAnnotation(icon:string){
    this.cancelPanels();
    const annotation = new Annotation();
    annotation.type = AnnotationType.SHAPE;
    annotation.iconMD=icon;
    if(this.timePlayer<500){
      annotation.time = 500;
    }else{
      annotation.time=this.timePlayer;
    }
    annotation.duration = this.annotationDefaultDurationTime;
    annotation.positionType = AnnotationPosition.TOP_RIGHT;
    annotation.theme = AnnotationTheme.DEFAULT;
    annotation.profil = false;
    annotation.interactionUrl = "";
    annotation.user = null;
    annotation.sound = false;
    annotation.width=9;
    annotation.height=16;
    annotation.positionX=20;
    annotation.positionY=20;
    annotation.textContent=""
    annotation.urlContent=""
    annotation.colorBack=store.getters.getAnnotationBackgroundColor|| "#FFFFFF"
    annotation.colorFront=store.getters.getAnnotationColor|| store.getters.getThemeColor
    var annotationCreated=await store.dispatch(CREATE_ANNOTATION, {weetID: this.weet.weetID, annotation: annotation});
    store.dispatch(SELECT_ANNOTATION,annotationCreated);
    store.dispatch(SEEK_PLAYER, annotation.time)
  }

  private openIconPanels(){
    this.showIconPanel=true;
  }

  private openShapePanels(){
    this.showShapePanel=true;
  }
  private cancelPanels(){
    this.showIconPanel=false;
    this.showShapePanel=false;
  }

  private convertFileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result as string);
      };
      reader.onerror = (error) => {
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  }
}
</script>

<!-- scope -->
<style scoped lang="scss">

.itemSelection{
  display: flex;
  align-items: center;
  cursor: pointer;
  width: 100%;
  .iconItem{
    margin-right: 8px;
    cursor: pointer;
  }
}

.containerIconsAnnotation{
  min-height: 400px;
  width: 580px;
  background: white;
  border-radius: 12px;
  padding:32px;
  &.forShape{
    width: 516px;
  }
  .titleIconChoose{
    font-size: 24px;
    font-weight: 900;
    margin-bottom: 16px;
  }
  .iconsPanel{
    display: flex;
    flex-wrap: wrap;
    .iconButtonSelector{
      cursor: pointer;
      padding: 4px;
      border-radius: 4px;
      color: var(--dark);
      &:hover{
        background: var(--light);
      }
    }
  }
  .lineButton{
    display: flex;
    padding-top: 16px;
    width: 100%;
    justify-content: center;
    .buttonAnnotationLine{
      margin: 8px;
    }
  }
}
</style>
